export default "__VITE_ASSET__e163233e__"